import {
  inOutSchema,
  prescriptionResponseSchema,
  type PrescriptionResponse,
  upDownSchema,
} from '../schema/refraction'
import type { ErpOrderRefraction } from '../types/api/erp'

const zero = (value: number | null | undefined) => value ?? 0

export const PrescriptionTransform = {
  fromErpOrderRefraction(
    erp: ErpOrderRefraction,
    options?: { optometristName?: string | null }
  ): PrescriptionResponse {
    return prescriptionResponseSchema.parse({
      ...erp,
      id: 0,
      create_date: erp.name,
      optometrist: null,
      optometrist_name: options?.optometristName ?? null,
      remark: erp.remark ?? '',
      r_cyl: zero(erp.r_cyl),
      l_cyl: zero(erp.l_cyl),
      r_axis: zero(erp.r_axis),
      l_axis: zero(erp.l_axis),
      r_add: zero(erp.r_add),
      l_add: zero(erp.l_add),
      r_visus: zero(erp.r_visus),
      l_visus: zero(erp.l_visus),
      r_pd: zero(erp.r_pd),
      l_pd: zero(erp.l_pd),
      prism: erp.prism ?? false,
      r_prism1: zero(erp.r_prism1),
      l_prism1: zero(erp.l_prism1),
      r_prism2: zero(erp.r_prism2),
      l_prism2: zero(erp.l_prism2),
      right_na_te: inOutSchema.parse(erp.right_na_te),
      left_na_te: inOutSchema.parse(erp.left_na_te),
      right_ha_ba: upDownSchema.parse(erp.right_ha_ba),
      left_ha_ba: upDownSchema.parse(erp.left_ha_ba),
    })
  },
}
